import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DomService } from '@ddt-web/dom';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { SharedQueryParamKey } from '@ddt-web/url';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgJsonEditorModule } from 'ang-jsoneditor';

import { ConfigDebugWindowComponent } from './components/config-debug-window/config-debug-window.component';
import { areDebugSurfacesAllowed } from './debug-surface.util';
import { ConfigIfDirective } from './directives/config-if-directive';

@UntilDestroy()
@NgModule({
	imports: [CommonModule, CwpNgFrameworkModule, DzButtonModule, GenericDirectivesModule, NgJsonEditorModule],
	declarations: [ConfigIfDirective, ConfigDebugWindowComponent],
	exports: [ConfigIfDirective]
})
export class ConfigLayerModule {
	constructor(private route: ActivatedRoute, private domService: DomService) {
		this.route.queryParamMap.pipe(untilDestroyed(this)).subscribe(queryParams => {
			const debugWindowQP = queryParams.get(SharedQueryParamKey.DEBUG_WINDOW);
			const showDebugMode = !!debugWindowQP;
			// To make sure that even if we import ConfigLayerModule from different modules in the app, the debugger is only shown once
			const debugWindowAlreadyPrepended: boolean = document.getElementsByTagName('ac-config-debug-window').length > 0;

			if (showDebugMode && areDebugSurfacesAllowed() && !debugWindowAlreadyPrepended) {
				this.domService.prependComponentToBody(ConfigDebugWindowComponent);
			}
		});
	}
}
